import React from 'react';
import { NavLink } from 'react-router-dom';
import { HomeIcon, CalendarIcon, BookOpenIcon, UsersIcon, UserPlusIcon, BarChartIcon, MapIcon, FileTextIcon, ClockIcon, MessageCircleIcon, UserCogIcon, LogOutIcon, CheckSquareIcon, MapPinIcon, AlertTriangleIcon, BuildingIcon, DatabaseIcon, LayersIcon, PieChartIcon, SettingsIcon, TrendingUpIcon, ThumbsUpIcon, FolderIcon, DownloadIcon, ShieldIcon, PlusIcon } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
interface SidebarProps {
  collapsed: boolean;
}
export function Sidebar({
  collapsed
}: SidebarProps) {
  const {
    role,
    logout
  } = useAuth();
  // Define navigation items for each role
  const instructorNavigation = [{
    name: 'Dashboard',
    href: '/dashboard',
    icon: HomeIcon
  }, {
    name: 'Mijn Rooster',
    href: '/schedule',
    icon: CalendarIcon
  }, {
    name: 'Mijn Trainingen',
    href: '/my-trainings',
    icon: BookOpenIcon
  }, {
    name: 'Aanwezigheid Registreren',
    href: '/attendance',
    icon: CheckSquareIcon
  }, {
    name: 'Locatie & Route',
    href: '/locations',
    icon: MapPinIcon
  }, {
    name: 'Notities & Inzichten',
    href: '/notes',
    icon: FileTextIcon
  }, {
    name: 'Beschikbaarheid',
    href: '/availability',
    icon: ClockIcon
  }, {
    name: 'Ziek Melden',
    href: '/sick-report',
    icon: AlertTriangleIcon
  }, {
    name: 'Contact Planner',
    href: '/contact',
    icon: MessageCircleIcon
  }];
  const plannerNavigation = [{
    name: 'Dashboard',
    href: '/dashboard',
    icon: HomeIcon
  }, {
    name: 'Trainingskalender',
    href: '/planner',
    icon: CalendarIcon
  }, {
    name: 'Nieuwe Training',
    href: '/training-wizard',
    icon: PlusIcon
  }, {
    name: 'Trainingen Overzicht',
    href: '/trainings',
    icon: BookOpenIcon
  }, {
    name: 'Instructeursbeheer',
    href: '/instructors',
    icon: UsersIcon
  }, {
    name: 'Klantenbeheer',
    href: '/crm',
    icon: BuildingIcon
  }, {
    name: 'Slipbaanbeheer',
    href: '/track-planning',
    icon: MapIcon
  }, {
    name: 'Problemen & Conflicten',
    href: '/conflicts',
    icon: AlertTriangleIcon
  }];
  const managerNavigation = [{
    name: 'Dashboard',
    href: '/dashboard',
    icon: HomeIcon
  }, {
    name: 'Planning Inzien',
    href: '/planner',
    icon: CalendarIcon
  }, {
    name: 'Rapportages',
    href: '/reports',
    icon: BarChartIcon
  }, {
    name: 'Gebruikersbeheer',
    href: '/user-management',
    icon: UserCogIcon
  }, {
    name: 'Klantactiviteit',
    href: '/customer-activity',
    icon: TrendingUpIcon
  }, {
    name: 'Feedback & Kwaliteit',
    href: '/feedback',
    icon: ThumbsUpIcon
  }, {
    name: 'Overzicht Trainingen',
    href: '/trainings',
    icon: BookOpenIcon
  }, {
    name: 'Instructeurs',
    href: '/instructors',
    icon: UsersIcon
  }];
  // Select navigation based on role
  let navigation = [];
  switch (role) {
    case 'instructor':
      navigation = instructorNavigation;
      break;
    case 'planner':
      navigation = plannerNavigation;
      break;
    case 'manager':
      navigation = managerNavigation;
      break;
    default:
      navigation = plannerNavigation;
    // Default to planner
  }
  return <div className={`${collapsed ? 'w-0 md:w-16' : 'w-64'} bg-white border-r border-gray-200 transition-all duration-300 ease-in-out flex flex-col h-full z-30 fixed md:relative shadow-md md:shadow-none`} data-id="element-1838">
      <div className="flex items-center justify-center h-16 border-b border-gray-200" data-id="element-1839">
        {!collapsed && <div className="flex items-center px-4" data-id="element-1840">
            <div className="w-8 h-8 bg-[#B61C1C] rounded flex items-center justify-center" data-id="element-1841">
              <span className="text-white font-bold text-sm" data-id="element-1842">VV</span>
            </div>
            <span className="ml-2 text-lg font-semibold text-gray-900" data-id="element-1843">
              VVGN Platform
            </span>
          </div>}
        {collapsed && <div className="w-8 h-8 bg-[#B61C1C] rounded flex items-center justify-center" data-id="element-1844">
            <span className="text-white font-bold text-sm" data-id="element-1845">VV</span>
          </div>}
      </div>
      <div className="flex-1 overflow-y-auto pt-5 pb-4" data-id="element-1846">
        <nav className="mt-5 px-2 space-y-1" data-id="element-1847">
          {navigation.map(item => <NavLink key={item.name} to={item.href} className={({
          isActive
        }) => `${isActive ? 'bg-[#B61C1C]/10 text-[#B61C1C] font-medium' : 'text-gray-600 hover:bg-gray-50 hover:text-[#B61C1C]'} ${collapsed ? 'justify-center' : ''} group flex items-center px-2 py-2 text-sm rounded-md transition-all duration-200`} data-id="element-1848">
              <item.icon className={`flex-shrink-0 h-5 w-5 ${collapsed ? '' : 'mr-3'}`} data-id="element-1849" />
              {!collapsed && <span data-id="element-1850">{item.name}</span>}
              {/* Active indicator */}
              {!collapsed && <NavLink to={item.href} className={({
            isActive
          }) => isActive ? 'ml-auto h-2 w-2 rounded-full bg-[#B61C1C]' : 'hidden'} data-id="element-1851">
                  <span className="sr-only" data-id="element-1852">Active</span>
                </NavLink>}
            </NavLink>)}
        </nav>
      </div>
      <div className="p-4 border-t border-gray-200" data-id="element-1853">
        {!collapsed ? <div className="flex flex-col space-y-3" data-id="element-1854">
            <div className="text-xs text-gray-500" data-id="element-1855">
              <p data-id="element-1856">VVGN Operations Platform</p>
              <p data-id="element-1857">v1.0.0</p>
            </div>
            <button onClick={logout} className="flex items-center text-gray-600 hover:text-[#B61C1C] text-sm font-medium transition-colors duration-200" data-id="element-1858">
              <LogOutIcon className="h-4 w-4 mr-2" data-id="element-1859" />
              Uitloggen
            </button>
          </div> : <div className="flex justify-center" data-id="element-1860">
            <button onClick={logout} className="text-gray-600 hover:text-[#B61C1C] transition-colors duration-200" title="Uitloggen" data-id="element-1861">
              <LogOutIcon className="h-4 w-4" data-id="element-1862" />
            </button>
          </div>}
      </div>
    </div>;
}